import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";
import ShoppingBasketIcon from "@material-ui/icons/ShoppingBasket";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import DevicesIcon from "@material-ui/icons/Devices";
import SendIcon from "@material-ui/icons/Send";
import { formatWallet, money } from "./helpers";
import { PointsSendTrigger } from "./CustomerServiceDialog";
import { tNegocio } from "./shared";
import { useStyles } from "./styles";

export default function CustomerStats({ customer, onOpenWallet }) {
  const classes = useStyles();
  const walletLabel = tNegocio("pages.customers.wallet");
  const items = [
    { key: "wallet", label: walletLabel, icon: AccountBalanceWalletIcon, value: formatWallet(customer.walletBalance, customer.walletCurrency), color: classes.metricPoints },
    { key: "purchases", label: tNegocio("pages.customers.purchases"), icon: ShoppingBasketIcon, value: customer.salesCount || 0 },
    { key: "total", label: tNegocio("pages.customers.totalPurchases"), icon: AttachMoneyIcon, value: money(customer.totalPaid), color: classes.metricMoney },
    { key: "services", label: tNegocio("pages.customers.active"), icon: DevicesIcon, value: customer.activeSubs || 0, color: classes.metricServices },
  ];
  return <div className={classes.detailStats}>
    {items.map(({ key, label, icon: Icon, value, color }) => <div key={key} className={classes.detailStat}>
      {key === "wallet" && onOpenWallet ?
        <Tooltip title={label}><IconButton size="small" aria-label={label} onClick={onOpenWallet}><Icon className={color} /></IconButton></Tooltip> :
        <Tooltip title={label}><span tabIndex={0} role="img" aria-label={label} className={classes.detailStatIcon}><Icon className={color} /></span></Tooltip>}
      {key === "wallet" ? <PointsSendTrigger customer={customer}>
        <IconButton size="small" color="primary" aria-label={tNegocio("pages.customers.sendWallet")}><SendIcon /></IconButton>
      </PointsSendTrigger> : null}
      <div className={classes.detailStatValue} aria-label={`${label}: ${value}`}>{value}</div>
    </div>)}
  </div>;
}
